// extracted by mini-css-extract-plugin
export var duration = "VideoDuration-module--duration--ae281";
export var fadeInAnimation = "VideoDuration-module--fadeInAnimation--c40a3";
export var smallPlay = "VideoDuration-module--smallPlay--9556b";